import {Component, OnInit, ViewChild} from '@angular/core';
import {ChatService} from '../chat.service';
import {QuestionInfo, QuestionInfoChatItem} from "../../model/question.model";
import {InputDirective} from "../../input/input.directive";
import {PreloaderService} from "../../service/preloader.service";
import {AuthenticationService} from "../../auth/_services/authentication.service";
import {PhoneService} from "../../service/phone.service";
import {QuizService} from "../../service/quiz.service";
import {UserReturningService} from "../../service/userReturning.service";

@Component({
    selector: 'app-profile',
    templateUrl: './profile.component.html',
    styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {
    @ViewChild(InputDirective, {static: false}) input: InputDirective;

    backLink = "/blocks";

    profile: {
        firstName: string,
        lastName: string,
        phoneNumber: number,
        email: string,
        address: string,
        city: string,
        state: number,
        zip: string
    } = {
        firstName: '',
        lastName: '',
        phoneNumber: 1,
        email: '',
        address: '',
        city: '',
        state: 1,
        zip: ''
    };
    copyProfile:{
        firstName: string,
        lastName: string,
        phone: number,
        email: string,
        type: string
    } = {
        firstName: '',
        lastName: '',
        phone: 1,
        email: '',
        type: ''
    };

    selectData = {
        question:{
            type:"SELECT",
            page:"profile",
            choices:[]
        },
        answer:{
            title:""
        }
    };

    goNext = true;
    popupShow = false;
    popupSuccess = false;
    showContinue = false;
    popupMessage = '';

    constructor(private chatService: ChatService,
                private authenticationService:AuthenticationService,
                private phoneService: PhoneService,
                private quizService: QuizService,
                private userReturningService: UserReturningService,
                private preloaderService:PreloaderService) {
    }

    ngOnInit() {
        this.getUserInfo();
        this.goToLastAnsweredQuestion();
    }

    getUserInfo() {
        this.chatService.getProfileInfo().subscribe(data => {

            console.log('avatar', data);

            this.selectData.question.choices = data.states;
            this.selectData.answer.title = data.result.state_id;

            this.preloaderService.hide();

            if(data.status){
                this.profile ={
                    firstName: data.result.first_name,
                    lastName: data.result.last_name,
                    phoneNumber: data.result.phone,
                    email: data.result.email,
                    address: data.result.address,
                    city: data.result.city,
                    state: data.result.state_id,
                    zip: data.result.zip
                };
                this.copyProfile = {firstName: this.profile.firstName, lastName: this.profile.lastName, phone: this.profile.phoneNumber, email: this.profile.email, type:'Application'};
                

            }
        });
    }

    handleProfileSave() {
        this.preloaderService.show();
        this.popupShow = false;
        this.showContinue = false;

        this.chatService.setProfileInfo(this.profile).subscribe((res:any) => {
            if(!this.copyProfile.firstName && !this.copyProfile.lastName && !this.copyProfile.email){
                this.copyProfile.firstName = this.profile.firstName;
                this.copyProfile.lastName = this.profile.lastName;
                this.copyProfile.email = this.profile.email;
                this.copyProfile.type = this.chatService.getChatKind().toUpperCase();
                this.authenticationService.alertPaperclip(this.copyProfile);
            }
            this.preloaderService.hide();
            if(res.status){
                this.popupShow = true;
                this.showContinue = true;
                this.popupSuccess = true;
            }else{
                this.showContinue = false;
                this.popupShow = true;
                this.popupSuccess = false;
            }

            // this.popupMessage = res.message;
            this.popupMessage = 'Your contact Information has been successfully updated';
        });
    }

    onAvatarChanged($event) {
        const avatar = $event[0];
        const token = this.authenticationService.getToken();
        this.preloaderService.show();
        this.showContinue = false;
        this.popupShow = false;

        this.chatService.uploadFile(avatar, token).subscribe((res:any) => {
            this.preloaderService.hide();
            if(res.status){
                this.popupShow = true;
                this.popupSuccess = true;
                this.phoneService.avatarChanged.next(true);
            }else{
                this.popupShow = true;
                this.popupSuccess = false;
            }
            this.popupMessage = res.message;
        });
    }

    changedState(){
        this.profile.state = this.input.inputComponentRef.instance.answer;

    }

    goToLastAnsweredQuestion(): void {
        let questionId = 1;
        let isFinding = false;

        this.quizService.getQuestionSteps().subscribe((data:any) => {
            if(data.status){
                if(data.result[0].progress == 80)
                    data.result[0].progress = 100;
                data.result.slice(0,3).forEach((el) => {
                    if (el.id >= questionId && +el.progress < 100 && !isFinding) {
                        questionId = el.id;
                        isFinding = true;
                    }
                    if (!isFinding) {
                        if (el.id === data.result.slice(0,3)[data.result.slice(0,3).length - 1].id && +el.progress === 100) {
                            questionId = el.id;
                            isFinding = true;
                        }
                    }
                });
                this.backLink = `/chat/${questionId}`;
            }
        });
    }
    gotoNext(){
        window.location.href = this.backLink;
    }
}
